export const getTenant = (tenantId) => ({ tenants }) =>
tenants.tenantsList.find(({ id }) => id === +tenantId);